import 'focus-visible/dist/focus-visible.min.js'

import React, { ReactElement } from 'react'
import { ThemeProvider } from 'styled-components'
import { theme } from '@elamajs/ui-kit'
import { HTTPProvider } from './context'
import Content from '@src/containers/UtmGenerator/content'

function UtmGenerator(): ReactElement {
  return (
    <ThemeProvider theme={theme}>
      <HTTPProvider>
        <Content />
      </HTTPProvider>
    </ThemeProvider>
  )
}

export default UtmGenerator
